import Swal from "sweetalert2";
import Clientes from "../children/bodys/ClientesBody";
import Fornecedores from "../children/bodys/FornecedoresBody";
import Produtos from "../children/bodys/ProdutosBody";

const useModalParametersController = () => {
  const returnEntityBody = (entity, setOpen = () => {}, setLoading) =>
    ({
      clientes: <Clientes setOpen={setOpen} setLoading={setLoading} />,
      fornecedores: <Fornecedores setOpen={setOpen} setLoading={setLoading} />,
      produtos: <Produtos setOpen={setOpen} setLoading={setLoading} />,
    }[entity] ?? <>Entidade não encontrada.</>);

  const closeDialog = async (setOpen, reason) => {
    if (reason === "backdropClick") return;

    const result = await Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja sair? As alterações não serão salvas.",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Não",
      confirmButtonText: "Sim",
    });

    if (!result.isConfirmed) return;

    setOpen(false);
  };

  return {
    closeDialog,
    returnEntityBody,
  };
};

export default useModalParametersController;
